export const APPSOURCE_NAMES = {
  VAE: 'vae',
  GENERIC: 'generic',
};
